var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheck2 = function SvgCheck2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.403 5.224a.833.833 0 0 1 .04 1.178l-7.778 8.333a.834.834 0 0 1-1.218 0L3.558 10.57A.833.833 0 1 1 4.777 9.43l3.28 3.514 7.168-7.68a.833.833 0 0 1 1.178-.04Z",
    fill: "currentColor"
  })));
};

export { SvgCheck2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi40MDI2IDUuMjI0MTJDMTYuNzM5IDUuNTM4MTUgMTYuNzU3MiA2LjA2NTQ4IDE2LjQ0MzIgNi40MDE5M0w4LjY2NTQyIDE0LjczNTNDOC41MDc4MiAxNC45MDQxIDguMjg3MTkgMTUgOC4wNTYyMSAxNUM3LjgyNTIyIDE1IDcuNjA0NiAxNC45MDQxIDcuNDQ3IDE0LjczNTNMMy41NTgxMSAxMC41Njg2QzMuMjQ0MDggMTAuMjMyMSAzLjI2MjI2IDkuNzA0ODIgMy41OTg3MiA5LjM5MDc5QzMuOTM1MTggOS4wNzY3NiA0LjQ2MjUxIDkuMDk0OTUgNC43NzY1MyA5LjQzMTQxTDguMDU2MjEgMTIuOTQ1M0wxNS4yMjQ4IDUuMjY0NzRDMTUuNTM4OCA0LjkyODI4IDE2LjA2NjEgNC45MTAxIDE2LjQwMjYgNS4yMjQxMloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";